// extracted by mini-css-extract-plugin
export default {"wrapper":"DesktopNavigation_wrapper__AR2WX"};